import axios from 'axios'
import {isArray} from 'lodash'
import {asResponse} from '../util'

const convertActivePageToSkip = (query = {}) => {
  let {activePage = '1'} = query
  activePage = parseInt(activePage)
  return (activePage - 1) * 10
}

export const ARCHIVES_SWR_KEY = ({suggested, query = {}}) => {
  console.log('1', {
    suggested,
    query
  })
  const skip = convertActivePageToSkip(query)
  console.log('2', skip)
  let {selectedNames = '', selectedTypes = ''} = query
  console.log('3', selectedNames)
  selectedNames = isArray(selectedNames) ? selectedNames : [selectedNames]
  selectedNames = selectedNames.join(',')
  const selectedNamesQueryParam = selectedNames.length ? `&selectedNames=${selectedNames}` : ''
  selectedTypes = isArray(selectedTypes) ? selectedTypes : [selectedTypes]
  selectedTypes = selectedTypes.join(',')
  const selectedTypesQueryParam = selectedTypes.length ? `&selectedTypes=${selectedTypes}` : ''
  return [`/bff/archives?skip=${skip}&limit=10&sort={"serviceName": -1, "versionName": -1, "environmentName": -1}&calcTotalCount=true&suggested=${suggested}&includeAggregates=true${selectedNamesQueryParam}${selectedTypesQueryParam}`, skip, suggested, selectedNames, selectedTypes]
}

export const getArchives = async (url) => {
  const resp = await asResponse(axios.get(url))
  let archives = resp.data ? (resp.data.results || []) : []
  let totalArchivesCount = resp.data ? (resp.data.metadata.totalCount || 0) : 0
  let archiveNames = resp.data ? (resp.data.names || []) : []
  return {archives, totalArchivesCount, archiveNames}
}

export const ARCHIVE_SWR_KEY = ({archiveId}) => [`/bff/archives/${archiveId}`, archiveId]

export const getArchive = async (url, archiveId) => {
  if (!archiveId) {
    return {
      archive: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${archiveId}', archiveId)))
  const archive = resp.data
  return {
    archive
  }
}

export const restoreArchive = async (archiveId, name, parentId) => {
  const resp = await asResponse(axios.post('/bff/archives/restore', {archiveId, name, parentId}))
  return resp.data
}

export const ignoreArchiveSuggestions = async (archive) => {
  const resp = await asResponse(axios.post('/bff/archives/ignore-suggestions', archive))
  return resp.data
}